module.exports = __webpack_public_path__ + "static/media/space_cloud_gcp.64dc8ae9.svg";